export function numberPercentage(n: number, p: number) {
  return n * (p / 100)
}
export function minusPercent(n: number, p: number) {
  return n - numberPercentage(n, p)
}
